import { get } from "lodash-es";
import { TENTATIVE_INCOME_NAME } from "web_myplann/Finances/constants";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import { MyPlannCzechResourcesDictionary } from "web_myplann/Infrastructure/Translations/CzechResourcesDictionary";
import { MyPlannEnglishResourcesDictionary } from "web_myplann/Infrastructure/Translations/EnglishResourcesDictionaty";
import { getResourcePath } from "web_myplann/Infrastructure/Translations/Resources";

const TENTATIVE_INCOME_NAMES = [
	MyPlannCzechResourcesDictionary,
	MyPlannEnglishResourcesDictionary,
]
	.map((dictionary) => get(dictionary, getResourcePath(TENTATIVE_INCOME_NAME)))
	.filter((name): name is string => typeof name === "string");

export const isDetailedIncome = (income: FinanceState["income"]) =>
	income.length > 1 ||
	(income.length === 1 && !TENTATIVE_INCOME_NAMES.includes(income[0].name));
